import { cva } from 'class-variance-authority'

export const HighlighterStyles = cva([], { variants: {} })
